import { useState, useEffect } from "react";
import { tenantSettingsService } from "src/services/tenantSettings";
import { HTTPSTATUSCODES } from "src/utils/constants";

export const useLicenseStatusCheck = () => {
	const [licenseStatusCheckEnabled, setLicenseStatusCheckEnabled] =
		useState<boolean>(false);

	useEffect(() => {
		const checkLicenseStatus = async () => {
			try {
				const response =
					await tenantSettingsService.checkIfLicenseStatusIsEnabled();

				if (response?.status === HTTPSTATUSCODES.StatusCodeSuccess) {
					setLicenseStatusCheckEnabled(response.data);
				}
			} catch (error) {
				console.error(error);
			}
		};

		checkLicenseStatus();
	}, []);

	return { licenseStatusCheckEnabled };
};
